import { render, staticRenderFns } from "./DepthController.vue?vue&type=template&id=8b00a8ec&scoped=true&"
import script from "./DepthController.vue?vue&type=script&lang=js&"
export * from "./DepthController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b00a8ec",
  null
  
)

export default component.exports